module.exports = __webpack_public_path__ + "assets/Secant2.30181e2be6a08d32c617db76df699d7a.gmt";


//////////////////
// WEBPACK FOOTER
// ./src/resources/levels/Gmt/Secant2.gmt
// module id = 990
// module chunks = 0